import React from 'react';
import HeadLessLayout from '../../../components/Layout/HeadLessLayout';
import AdminLogin from './AdminLogin';
import messages from '../../../locale/jsonMessages';

export default async function action({ store, intl }, context) {

  const intlInstance = intl || context?.intl;

  const title = intlInstance && messages?.adminLogInTabTitle
    ? intlInstance.formatMessage(messages.adminLogInTabTitle)
    : 'Admin Login';


  const isAdminAuthenticated = store?.getState()?.runtime?.isAdminAuthenticated;

  if (isAdminAuthenticated) {
    return { redirect: '/siteadmin' };
  }

  return {
    title,
    component: (
      <HeadLessLayout>
        <AdminLogin title={title} />
      </HeadLessLayout>
    ),
  };
}